const updateObject = <T>(oldObject: T, updatedProperties: object): T => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export default updateObject;
